import { render, staticRenderFns } from "./DestinationEdit.vue?vue&type=template&id=15c9005e"
import script from "./DestinationEdit.vue?vue&type=script&lang=js"
export * from "./DestinationEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports